import { createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a1719d90")

_pushScopeId("data-v-a1719d90")
const _hoisted_1 = { class: "modal-overlay" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "modal-click-overlay",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeOnClick && _ctx.back()))
    }),
    _createVNode("div", {
      class: ["modal-contents", _ctx.contentClass],
      style: {
                padding: '8px ' + _ctx.sizes.padding,
                'max-width': _ctx.sizes.max
            }
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 6)
  ], 512)), [
    [_vShow, _ctx.isOpen]
  ])
})